module.exports = __webpack_public_path__ + "img/ring_y_o_1_null.0dcc3312.png";